import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTextTypography = styled(Typography)(({ theme }) => ({
  ['&.default']: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    color: theme.palette.text.primary,
  },
  ['&.biggerText']: {
    ...theme.typography.h3,
  },
  ['&.mediumText']: {
    ...theme.typography.h4,
    fontSize: '24px',
  },
  ['&.smallText']: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    color: theme.palette.text.lightBlack,
  },
  ['&.errorText']: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    color: theme.palette.error.lighter,
  },
  ['&.examBalance']: {
    ...theme.typography.h2,
    color: theme.palette.text.primary,
  },
  ['&.exams']: {
    ...theme.typography.h4,
    fontWeight: '600',
    color: theme.palette.text.primary,
  },
  ['&.no-of-exams']: {
    ...theme.typography.h5,
    fontSize: '16px',
    color: theme.palette.text.lightBlack,
  },
  ['&.blackText']: {
    ...theme.typography.h4,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.black,
  },
  ['&.offerText']: {
    fontFamily: theme.typography.fontFamilyTitle,
    fontSize: '12px',
    fontWeight: 600,
    color: theme.palette.text.lightDark,
  },
  ['&.month_year']: {
    ...theme.typography.h2,
    fontSize: '16px',

    color: theme.palette.text.black,
  },
  ['&.review_count']: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    fontSize: '16px',
    color: theme.palette.text.black,
  },
  ['&.no_completed_exams']: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: '16px',
    color: theme.palette.text.darkPrimary,
  },
  ['&.view_invoices']: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    fontSize: '14px',
    color: theme.palette.text.lightBlue,
  },
}));
const TextTypography = (props) => {
  return (
    <StyledTextTypography component={props.component} sx={props.sx} className={props.className}>
      {props.children}
    </StyledTextTypography>
  );
};
export default TextTypography;
